// extracted by mini-css-extract-plugin
export default {"header":"_5gAnlNvLxj4Ezxwjn9QS","info":"tS7ftGivG_bBIZ83rPBQ"};